import {
  REPORT_WHOLESALER_REPORT_BYID_REQUEST,
  REPORT_WHOLESALER_REPORT_BYID_SUCCESS,
  REPORT_WHOLESALER_REPORT_BYID_FAILURE,
  REPORT_WHOLESALER_REPORT_BYID_SEARCH_REQUEST,
  REPORT_WHOLESALER_REPORT_BYID_SEARCH_SUCCESS,
  REPORT_WHOLESALER_REPORT_BYID_SEARCH_FAILURE,
  WHOLESALER_REPORT_BYID_DATE_SEARCH_REQUEST,
  WHOLESALER_REPORT_BYID_DATE_SEARCH_SUCCESS,
  WHOLESALER_REPORT_BYID_DATE_SEARCH_FAILURE,
  REPORT_WHOLESALER_MONTH_REPORT_BYID_REQUEST,
  REPORT_WHOLESALER_MONTH_REPORT_BYID_SUCCESS,
  REPORT_WHOLESALER_MONTH_REPORT_BYID_FAILURE,
  REPORT_WHOLESALER_WEEK_REPORT_BYID_REQUEST,
  REPORT_WHOLESALER_WEEK_REPORT_BYID_SUCCESS,
  REPORT_WHOLESALER_WEEK_REPORT_BYID_FAILURE,
  WHOLESALER_REPORT_MONTH_BYID_DATE_SEARCH_REQUEST,
  WHOLESALER_REPORT_MONTH_BYID_DATE_SEARCH_SUCCESS,
  WHOLESALER_REPORT_MONTH_BYID_DATE_SEARCH_FAILURE,
  WHOLESALER_REPORT_WEEK_BYID_DATE_SEARCH_REQUEST,
  WHOLESALER_REPORT_WEEK_BYID_DATE_SEARCH_SUCCESS,
  WHOLESALER_REPORT_WEEK_BYID_DATE_SEARCH_FAILURE,
  WHOLESALER_REPORT_MONTH_BYID_DATE_SEARCH_RESET,
  WHOLESALER_REPORT_WEEK_BYID_DATE_SEARCH_RESET,
  WHOLESALER_REPORT_BYID_DATE_SEARCH_RESET,
} from "./WholesalerReportByIdTypes";

// Wholesaler Month Report By Id Actions
export const wholesalerReportMonthByIdRequest = (wholesalerId, pageNo) => ({
  type: REPORT_WHOLESALER_MONTH_REPORT_BYID_REQUEST,
  payload: { wholesalerId, pageNo },
});

export const wholesalerReportMonthByIdSuccess = (report) => ({
  type: REPORT_WHOLESALER_MONTH_REPORT_BYID_SUCCESS,
  payload: report,
});

export const wholesalerReportMonthByIdFailure = (error) => ({
  type: REPORT_WHOLESALER_MONTH_REPORT_BYID_FAILURE,
  payload: error,
});

// Wholesaler Week Report By Id Actions
export const wholesalerReportWeekByIdRequest = (wholesalerId, pageNo) => ({
  type: REPORT_WHOLESALER_WEEK_REPORT_BYID_REQUEST,
  payload: { wholesalerId, pageNo },
});

export const wholesalerReportWeekByIdSuccess = (report) => ({
  type: REPORT_WHOLESALER_WEEK_REPORT_BYID_SUCCESS,
  payload: report,
});

export const wholesalerReportWeekByIdFailure = (error) => ({
  type: REPORT_WHOLESALER_WEEK_REPORT_BYID_FAILURE,
  payload: error,
});

// Wholesaler Day Report By Id Actions
export const wholesalerReportByIdRequest = (wholesalerId, pageNo) => ({
  type: REPORT_WHOLESALER_REPORT_BYID_REQUEST,
  payload: { wholesalerId, pageNo },
});

export const wholesalerReportByIdSuccess = (report) => ({
  type: REPORT_WHOLESALER_REPORT_BYID_SUCCESS,
  payload: report,
});

export const wholesalerReportByIdFailure = (error) => ({
  type: REPORT_WHOLESALER_REPORT_BYID_FAILURE,
  payload: error,
});

//Wholesaler Month By Id Date Search
export const wholesalerReportMonthByIdDateSearchRequest = (queryObj) => ({
  type: WHOLESALER_REPORT_MONTH_BYID_DATE_SEARCH_REQUEST,
  payload: queryObj,
});

export const wholesalerReportMonthByIdDateSearchSuccess = (results) => ({
  type: WHOLESALER_REPORT_MONTH_BYID_DATE_SEARCH_SUCCESS,
  payload: results,
});

export const wholesalerReportMonthByIdDateSearchFailure = (error) => ({
  type: WHOLESALER_REPORT_MONTH_BYID_DATE_SEARCH_FAILURE,
  payload: error,
});
export const wholesalerReportMonthByIdDateSearchReset = () => ({
  type: WHOLESALER_REPORT_MONTH_BYID_DATE_SEARCH_RESET,
  });
//Wholesaler Week By Id Date Search
export const wholesalerReportWeekByIdDateSearchRequest = (queryObj) => ({
  type: WHOLESALER_REPORT_WEEK_BYID_DATE_SEARCH_REQUEST,
  payload: queryObj,
});

export const wholesalerReportWeekByIdDateSearchSuccess = (results) => ({
  type: WHOLESALER_REPORT_WEEK_BYID_DATE_SEARCH_SUCCESS,
  payload: results,
});

export const wholesalerReportWeekByIdDateSearchFailure = (error) => ({
  type: WHOLESALER_REPORT_WEEK_BYID_DATE_SEARCH_FAILURE,
  payload: error,
});
export const wholesalerReportWeekByIdDateSearchReset = () => ({
  type: WHOLESALER_REPORT_WEEK_BYID_DATE_SEARCH_RESET,
  });

//Wholesaler Day By Id Date Search
export const wholesalerReportByIdDateSearchRequest = (queryObj) => ({
  type: WHOLESALER_REPORT_BYID_DATE_SEARCH_REQUEST,
  payload: queryObj,
});

export const wholesalerReportByIdDateSearchSuccess = (results) => ({
  type: WHOLESALER_REPORT_BYID_DATE_SEARCH_SUCCESS,
  payload: results,
});

export const wholesalerReportByIdDateSearchFailure = (error) => ({
  type: WHOLESALER_REPORT_BYID_DATE_SEARCH_FAILURE,
  payload: error,
});
export const wholesalerReportByIdDateSearchReset = () => ({
  type: WHOLESALER_REPORT_BYID_DATE_SEARCH_RESET,
  });

//Wholesaler By Id Search
export const wholesalerReportByIdSearchRequest = (wholesalerId) => ({
  type: REPORT_WHOLESALER_REPORT_BYID_SEARCH_REQUEST,
  payload: wholesalerId,
});

export const wholesalerReportByIdSearchSuccess = (results) => ({
  type: REPORT_WHOLESALER_REPORT_BYID_SEARCH_SUCCESS,
  payload: results,
});

export const wholesalerReportByIdSearchFailure = (error) => ({
  type: REPORT_WHOLESALER_REPORT_BYID_SEARCH_FAILURE,
  payload: error,
});
